import { render, staticRenderFns } from "./DashboardAppsRow.vue?vue&type=template&id=0afad178&scoped=true&"
import script from "./DashboardAppsRow.vue?vue&type=script&lang=js&"
export * from "./DashboardAppsRow.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAppsRow.vue?vue&type=style&index=0&id=0afad178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afad178",
  null
  
)

export default component.exports